/*eslint-disable */
var $ = window.jQuery = require('jquery');
import root from '../../_helpers/roots';
let dataUrl = root.latestCourses.link;
import axios from 'axios';
import newCourseListSmall from '../../components/newCourseListSmall/index'
import userCourseDescription from '../../components/userCourseDescription/index'

export default {
  name: 'course-detail',
  components: {
    'newcourse-list-small': newCourseListSmall,
    'user-course-description': userCourseDescription
  },
  data () {
    return {

    }
  },
  computed: {

   },
  mounted () {
    $('body').addClass('course-detail-page');
  },
  methods: {
    // removeCollasped(){
    //   $('.user-dashboard').removeClass('actvCollaspe');
    //   $('.boxesCollaspeActv').removeClass('actvCollaspe');
    // }

  },
  created(){

  },
  beforeCreate: function() {
    $('body').addClass('course-detail-page');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('course-detail-page');
    $('.user-dashboard').removeClass('actvCollaspe');
    $('.boxesCollaspeActv').removeClass('actvCollaspe');
    next();
  },
}
